import styled from "styled-components";
import { mediaquery, unitizedPx } from "@badi/badi-components";

export const BookingLeaveRoot = styled.div`
  ${mediaquery.md`  
    min-width: ${unitizedPx(53)};
  `}
`;
